module.exports = __webpack_public_path__ + "img/home_menu_13_default.9a138b71.png";